import { styled } from '@withjoy/joykit';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';

export const StyledJoyLogo = styled(JoyLogo)`
  margin: ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[2]};
`;
